/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbSpinnerModule,
  NbCheckboxModule,
 // NbDialogRef,
} from '@nebular/theme';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TokenInterceptorService } from './shared/filters/token-interceptor.service';
import { AuthenticationService } from './shared/services/authentication.service';
import { LoadingBarService, LoadingBarModule } from 'ng2-loading-bar';
import { RestService } from './shared/services/rest/rest.service';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { LoginModule } from './pages/login/login.module';
import { AuthCustomModule } from './pages/auth/auth-custom.module';
import { GestaoUserTerceiroModule } from './pages/gestao-user-terceiro/gestao-user-terceiro.module';
import { GestaoUserTerceiroRoutingModule } from './pages/gestao-user-terceiro/gestao-user-terceiro-routing.module';
import { NgxDatatableModule, DimensionsHelper } from '@swimlane/ngx-datatable';
import { EncriptyUtilService } from './shared/services/encripty-util.service';
import { CommonService } from './shared/services/commom.service';
import { HttpService } from './shared/services/http/http-client.service';
import { SpringDatatablePaginationService } from './shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { ResetSenhaModule } from './pages/reset-senha/reset-senha.module';
import { GestaoFuncionariosRoutingModule } from './pages/gestao-funcionarios/gestao-funcionarios-routing.module';
import { GestaoFuncionariosModule } from './pages/gestao-funcionarios/gestao-funcionarios.module';
import { FinanceiroModule } from './pages/financeiro/financeiro.module';
import { FinanceiroRoutingModule } from './pages/financeiro/financeiro-routing.module';
import { InputCounterModule } from 'ng4-input-counter';
import { BackofficeModule } from './pages/backoffice/backoffice.module';
import { BackofficeRoutingModule } from './pages/backoffice/backoffice-routing.module';
import { NgxMaskModule } from 'ngx-mask';
import { CardNoNameModule } from './pages/card-no-name/card-no-name.module';
import { CardNoNameRoutingModule } from './pages/card-no-name/card-no-name-routing.module';
import { PagamentoInteligenteModule } from './pages/pagamento-inteligente/pagamento-inteligente.module';
import { PagamentoInteligenteRoutingModule } from './pages/pagamento-inteligente/pagamento-inteligente-routing.module';
import { CompraOnlineModule } from './pages/compra-online/compra-online.module';
import { CompraOnlineRoutingModule } from './pages/compra-online/compra-online-routing.module';
import { DashboardModule } from './pages/dashboard/dashboard.module';
import { AuthGuardService } from './shared/filters/auth-guard.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { SplitVendasRoutingModule } from './pages/split-vendas/split-vendas-routing.module';
import { SplitVendasModule } from './pages/split-vendas/split-vendas.module';
import { BoletoPrePagoRoutingModule } from './pages/boleto-pre-pago/boleto-pre-pago-routing.module';
import { BoletoPrePagoModule } from './pages/boleto-pre-pago/boleto-pre-pago.module';
import { ReusoAutomaticoRoutingModule } from './pages/reuso-automatico/reuso-automatico-routing.module';
import { ReusoAutomaticoModule } from './pages/reuso-automatico/reuso-automatico.module';
import { MonitoramentoRoutingModule } from './pages/monitoramento/monitoramento-routing.module';
import { MonitoramentoModule } from './pages/monitoramento/monitoramento.module';
import { BnNgIdleService } from 'bn-ng-idle';
import { LogInterceptor } from './interceptors/interceptor-log';
import { AlterarSenhaModule } from './pages/alterar-senha/alterar-senha.module';
import { ComponentstModule } from './shared/components/components.module';
import { DirectivesModule } from './shared/directive/directives.module';




@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbCheckboxModule,
    ThemeModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    FormsModule,
    SimpleNotificationsModule.forRoot(),
    InputCounterModule.forRoot(),
    ReactiveFormsModule,
    AuthCustomModule ,
    LoginModule,
    ResetSenhaModule,
    GestaoUserTerceiroModule,
    GestaoUserTerceiroRoutingModule,
    NgxDatatableModule,
    LoadingBarModule,
    NgxDatatableModule,
    GestaoFuncionariosRoutingModule,
    GestaoFuncionariosModule,
    FinanceiroModule,
    FinanceiroRoutingModule,
    BackofficeModule,
    BackofficeRoutingModule,
    PagamentoInteligenteModule,
    PagamentoInteligenteRoutingModule,
    NgxMaskModule.forRoot(),
    CardNoNameModule,
    CardNoNameRoutingModule,
    CompraOnlineModule,
    CompraOnlineRoutingModule,
    DashboardModule,
    NgxSpinnerModule,
    SplitVendasRoutingModule,
    SplitVendasModule,
    BoletoPrePagoRoutingModule,
    BoletoPrePagoModule,
    ReusoAutomaticoRoutingModule,
    ReusoAutomaticoModule,
    MonitoramentoRoutingModule,
    MonitoramentoModule,
    AlterarSenhaModule,
    ComponentstModule,

  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true},
    { provide : LocationStrategy , useClass: HashLocationStrategy},
    AuthenticationService,
    EncriptyUtilService,
    CommonService,
    HttpService,
    LoadingBarService,
    RestService,
    SpringDatatablePaginationService,
    DimensionsHelper,
    AuthGuardService,
    AuthenticationService,
    NgxSpinnerService,
    BnNgIdleService,
    {
      provide : HTTP_INTERCEPTORS,
      useClass : LogInterceptor,
      multi : true
    },

  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
}
